<template>
  <div>
    <co-dialog
      v-model="showDialog"
      width="520"
      :title="dialogContent.title"
      :is-cancel-left="false"
      :show-footer="false"
    >
      <component
        :is="curCom"
        :data="dialogContent"
        @closeParentDialog="showDialog=false"
        @after-download="afterDownload"
        @retry="retry"
      />
    </co-dialog>
    <!-- 修改扩展名弹框 -->
    <co-toast
      v-model="showToast"
      :is-auto="true"
      :is-link="false"
      :toast-info="toastContent"
    />
  </div>
</template>
<script>
import coToast from 'components/common/toast/index.vue'
import coDialog from 'components/common/dialog/index.vue'
import coTips from 'components/common/tips/index.vue'
import { getSizeNum, compareVersion, getLanguage, getLDwebtooLan } from 'js/util/util'
import _$ from 'js/api/getdata'
import Cookie from 'js/lib/cookie'
import LdTool from 'js/lib/ldtool'
import { isExistPolicy, sendLogBuryingPointMethods, doFileExistJob } from 'js/api/privateApi/private-apis'
import { initLdTool, deliveryDownload, setLanguage, downloadCore, runStatus } from 'js/ldTool'
import coConfirm from 'components/common/confirm/index.vue'
import { fileEditCheck } from 'js/api/download/download'
import normal from './normal.vue'
import notsupport from './notsupport.vue'
import download from './download.vue'
import edit from './edit.vue'
const SUPPORT_BATCH_DOWNLOAD_VERSION = '6.2.1.3'
// 重试方法
let retryFuc = null


export default {
  components: {
    coToast,
    coTips,
    coDialog,
    normal,
    notsupport,
    download,
    edit,
    coConfirm,
  },
  data() {
    return {
      // 显示提示
      showToast: false,
      toastContent: {},
      // 显示弹框
      showDialog: false,
      curCom: '',
      dialogContent: {
        component: '',
        title: '',
        type: '',
        otherData: {},
        metadata: {},
      },
      metadata: {},
    }
  },
  computed: {
    accountId() {
      return this.$store.getters.accountId
    },
    uId() {
      return this.$store.getters.uId
    },
  },
  methods: {
    /**
             * 最近访问的上报
             */
    sendRecent(d) {
      Object.assign(d, { arrayFormat: true })
      _$.postData('sendRecent', d)
    },
    getExtraData(metadata) {
      const { neid, nsid } = metadata
      return _$.postData('extraMeta', { json: JSON.stringify([{ neid, nsid }]) })
    },
    /**
             * web本地编辑打开
             */
    async init(metadataParam) {
      const me = this
      // 文件信息
      const metadata = metadataParam || {}
      me.metadata = metadata
      const {
        neid, nsid, path, path_type: pathType,
        from, prefix_neid: prefixNeid,
      } = metadata
      const extraMetaData = await this.getExtraData(metadata)
      const ifEditing = extraMetaData.data
        && extraMetaData.data.comments
        && extraMetaData.data.comments[0].beingEdited
      if (ifEditing) {
        window.$confirm.show({
          value: true,
          isShow: true,
          onlyOne: true,
          title: '提示',
          content: this.$t('文件编辑中，不可打开本地编辑'),
          sure() {
            window.$confirm.hide()
          },
        })
        return
      }
      doFileExistJob({
        path,
        path_type: pathType,
        neid,
        nsid,
        from,
        prefix_neid: prefixNeid,
      }).then(() => {
        // 检查是否超限如果超限，给出提示
        const isLimit = me.checkSizeLimit(metadata)
        if (isLimit) {
          me.dialogContent = {
            component: 'normal',
            title: '文件大小超出上限',
            type: 'sizeLimit',
            otherData: metadata,
            metaData: metadata,
          }
          me.$nextTick(() => {
            me.curCom = me.dialogContent.component
            me.showDialog = true
          })
        }
        // 交验是否设置了审批规则
        isExistPolicy({neid, nsid, path}, ['download', 'upload'])
          .then(() => {
            this.startWebTool(metadata)
            const pathSplit = path.split('/')
            sendLogBuryingPointMethods({
              category: 0,
              action: 15,
              path_type: pathType,
              nsid,
              neid,
              entityStr1: pathSplit.pop(),
              entityStr2: pathSplit.join('/') === '' ? '/' : pathSplit.join('/'),
            })
          })
          .catch(() => {
            this.$confirm.show({
              value: true,
              isShow: true,
              onlyOne: true,
              title: this.$t('提示'),
              content: this.$t('此目录因设置了审批规则,无法执行此操作'),
              sure: () => {
                this.$confirm.hide()
              },
            })
          })
      })
    },
    /**
             * 启动webtool
             */
    startWebTool(metadata) {
      if (window.LDTool) {
        window.LDTool.edit(metadata)
      } else {
        this.initLdTool(metadata, !!metadata)
      }
    },
    /**
             * 检测文件大小上限
             * @param {*} metadata
             * @param {*} successCb 检测通过，未超过上限
             * @param {*} baseNum 基底是200M，超过就表示超过大小上限
             */
    checkSizeLimit(metadata, baseNum = '200 M') {
      // 这里不能用size要用bytes
      const size = metadata.bytes// getSizeNum(metadata.size)
      const base = getSizeNum(baseNum)
      if (size <= base) {
        return false
      }
      return true
    },
    // /**
    //  * 检查单文件的病毒
    //  */
    // async checkVirus(metadata) {
    //     let downloadUrl = singleDownloadUrl(metadata);
    //     let probeUrl = downloadUrl + '&probe=1'; // url中带probe，且不为空，是为了试探
    //     return _$.getData(probeUrl)
    // },
    /**
             * 浏览器不支持的弹框
             */
    notSupportCallback() {
      this.showDlg('notSupportCallback')
    },
    /**
             * 弹一个下载的提示
             */
    download() {
      this.showDlg('download')
    },
    /**
             * 下载后的弹框
             */
    afterDownload() {
      this.showDlg('edit')
    },
    /**
             * 重试
             */
    retry() {
      this.initLdTool(this.metadata, !!this.metadata)
    },
    /**
             * 弹一个编辑的提示
             */
    edit() {
      this.showDlg('edit')
    },
    // session相关的提示
    sessionOccupied() {
      this.showDlg('sessionOccupied')
    },
    /**
             * 未检测到相应的程序
             */
    // noUseableTool() {
    // },
    showDlg(type) {
      const cfg = {
        edit: {
          component: 'edit',
          title: '安装zBox WebTool插件',
          type: 'connectErrorCatch',
          otherData: this.metadata,
        },
        download: {
          component: 'download',
          title: '安装zBox WebTool插件',
          type: 'allErrorCallback',
          otherData: this.metadata,
          metaData: this.metadata,
        },
        notSupportCallback: {
          component: 'notsupport',
          title: '请升级您的浏览器版本',
          type: 'notSupportCallback',
          otherData: this.metadata,
          metaData: this.metadata,
        },
        sessionOccupied: {
          component: 'normal',
          title: '提示',
          type: 'sessionOccupied',
          otherData: this.metadata,
        },
      }
      this.dialogContent = cfg[type]
      this.$nextTick(() => {
        this.curCom = this.dialogContent.component
        this.showDialog = true
      })
    },
    /**
             * 初始化工具
             */
    initLdTool(metaData, isEdit, cb) {
      const me = this
      // 用户id
      const uid = this.uId
      // account_id客户端需要字符串类型
      const accountId = `${this.accountId}`
      const sid = Cookie.get('X-LENOVO-SESS-ID')
      window.LDTool = new LdTool({
        notSupportCallback: me.notSupportCallback,
        allErrorCallback: isEdit ? me.download : me.edit,
        editCallback() {
          // 最近访问的上报
          const data = { fileType: 1, neids: [metaData.neid], nsid: metaData.nsid }
          me.sendRecent(data)
          me.showDialog = false
        },
        sessionOccupied: me.sessionOccupied,
        // noUseableTool: me.noUseableTool,
        connectErrorCatch: me.edit,
      })
      window.LDTool.init(uid, sid, {
        initCallback: () => {
          // 表示ldtool在公有网盘下使用
          let isExe = false
          const timer = setTimeout(() => {
            isExe = true
            window.LDTool.edit(metaData, () => {
              // console.log('finished', rest)
              if (cb) {
                cb()
              }
            })
          }, 2000)
          window.LDTool.setOption({
            language: getLanguage() === 'en' ? 'en' : 'zh_cn',
            server_type: 2,
          }, () => {
            clearTimeout(timer)
            if (isExe) return
            window.LDTool.edit(metaData, () => {
              // console.log('finished', rest)
              if (cb) {
                cb()
              }
            })
          })
        },
        paramsJson: JSON.stringify({ account_id: accountId }),
      })
    },
    /**
             * 5.1.0新增接口，判断用户是否受到管控，用于本地编辑，不可用于链接弹框，
             * 因为用户即使受管控，在链接需审批模式下，也可以发外链
             */
    async isOdc() {
      const odc = await _$.getData('getOdc').then((res) => res).catch(() => ({}))
      return odc
    },
    /**
     * 查询是否受下载管控
     * * */
    async isDownloadPrivilege(pathType) {
      try {
        await getDownloadPrivilegeInPreview(pathType)
        return false
      } catch (error) {
        const { response } = error
        if (response.data) {
          this.$toast.simpleShow(response.data.message, 'warn')
          return true
        }
      }
    },
    /**
     * 外链下载方法
     * @param {Object} metadata info 信息isShowPath
     * @param {string} metadata.user_info 外链信息
     * @param {boolean} metadata.isShowTrans 外链信息
     * @param {boolean} metadata.isShowPath 外链信息
     * @param {Object} metadata.delivery_info 外链信息
     * @param {string} metadata.delivery_info.delivery_code  外链的code码
     * @param {string} metadata.delivery_info.LBC 数据中心标记
     * @param {string} metadata.delivery_info.token 带密码的外链需要的验证码
     * @param {Array} metadata.delivery_info.metadata 为数组，内容为外链的meta信息，不一定完整的metadata，至少提供下载的必须项path、is_dir、rev
     * @param {function} callback 回调函数
     * * */
    async deliveryDownload(metadata, callback) {
      retryFuc = () => {
        // 重试之前要重置LDTool对象
        window.LDTool = null
        this.deliveryDownload(metadata, callback)
      }
      try {
        await this.checkedWebToolVersion(SUPPORT_BATCH_DOWNLOAD_VERSION)
      } catch (e) {
        callback && callback()
        this.upgradeWebToolTip()
        return
      }
      window.LDTool.setOption(
        {
          language: getLDwebtooLan(),
        },
        () => {
          downHander()
        },
      )
      const downHander = () => {
        deliveryDownload(
          {
            metadata,
            isShowPath: true,
            isShowTrans: true,
          },
          (...arg) => {
            retryFuc = null
            callback && callback(arg)
          },
        )
      }
    },
    /**
     * 下载方法 支持大文件下载/批量下载
     * 可以替换掉download方法
     * @param {Object} params
     * @param {Object|Array|any} params.metadata 要下载的meta信息
     * @param {boolean} params.isNeedPath 是否需要path 在metadata不是数组的时候生效
     * @param {boolean} params.isShowPath  为是否显示本地下载位置选择框，false则使用默认下载地址 仅仅在metadata是数组的时候生效
     * @param {boolean} params.isShowTrans   为是否显示传输列表 仅仅在metadata是数组的时候生效
     * @param {function} callback 回调函数
     */
    async downloadCore(
      { metadata, isNeedPath = false, isShowPath = false, isShowTrans = false },
      callback,
    ) {
      retryFuc = () =>
        this.downloadCore(
          {
            metadata,
            isNeedPath,
            isShowPath,
            isShowTrans,
          },
          callback,
        )
      console.log('downloadCore')
      try {
        await this.checkedWebToolVersion(SUPPORT_BATCH_DOWNLOAD_VERSION, true)
      } catch (e) {
        this.upgradeWebToolTip()
        return
      }

      window.LDTool.setOption(
        {
          language: getLDwebtooLan(),
        },
        () => {
          downHander()
        },
      )
      const downHander = () => {
        downloadCore(
          {
            metadata,
            isShowPath: true,
            isShowTrans: true,
          },
          (...arg) => {
            retryFuc = null
            callback && callback(arg)
          },
        )
      }
    },
    /** *
     * 修改webtool语言
     * @param {string} lang 语言
     * @param {function} callback 回调函数
     * * */
    setLanguage(lang, callback) {
      if (window.LDTool) {
        setLanguage(lang, callback)
      } else {
        callback && callback()
      }
    },
    /**
     * 检查webtool是否小于指定版本
     * @param {string} version
     * @returns <Promise>
     */
    checkedWebToolVersion(version, needLogin = false) {
      return new Promise((resolve, reject) => {
        const compareVersionCallBack = ({ info = {} } = {}) => {
          this.LDconnectSuccess()
          console.log('checkedWebToolVersion')
          if (info.tool_version && compareVersion(info.tool_version, version) < 0) {
            return reject()
          }
          return resolve()
        }

        if (window.LDTool) {
          runStatus(compareVersionCallBack, compareVersionCallBack)
        } else {
          // 初始化
          initLdTool(
            {
              notSupportCallback: this.notSupportCallback,
              allErrorCallback: this.download,
              sessionOccupied: this.sessionOccupied,
              noUseableTool: this.noUseableTool,
              connectErrorCatch: this.connectErrorCatch,
              successCallback: this.LDconnectSuccess,
              needLogin,
            },
            () => {
              runStatus(compareVersionCallBack, compareVersionCallBack)
            },
          )
        }
      })
    },
    LDconnectSuccess() {
      $confirm.show({ rightIcon: '' })
    },
    // 升级webTool 提示
    upgradeWebToolTip() {
      // 如果有其他弹窗则隐藏
      if ($confirm.getInstance()) {
        $confirm.hide()
      }
      this.$nextTick(() => {
        this.dialogContent = {
          component: 'normal',
          type: 'upgradeWebtool',
        }
        this.$nextTick(() => {
          this.curCom = this.dialogContent.component
          this.showDialog = true
        })
      })
    },
    pause(callback) {
      if(window.LDTool){
        window.LDTool.Pause({},(res)=>{
          callback(res)
        })
      }
    },
    loginOut(){
      if(window.LDTool){
        window.LDTool.outlogin()
      }
    },
    getTaskInfo(callback) {
      if (window.LDTool) {
        window.LDTool.taskInfo( (res) => {
          callback(res)
        })
      } else{
        initLdTool(
          {
            allErrorCallback:() => {
              callback()
            },
            successCallback: () => {
              runStatus(()=>{
                window.LDTool.taskInfo( (res) => {
                  callback(res)
                })
              },() => {
                  callback()
                }
              )
            },
          },
        )
      }
    }

  },
}
</script>
